import { Axios } from "../../../util";
import axios from "axios";

const searchManageSendOtpAPI = async (payload) => {
  try {
    const res = await Axios.post('/api/request/getManageOtp',payload);
    return res.data;
  } catch (error) {
    console.error("There was an error fetching the API data!", error);
    throw error;
  }
};


export { searchManageSendOtpAPI
        };
